import { TramitadorFilter } from './tramitador.filter';
export class TramitadorReport {
  listDenuncies: any[];
  fechaInicio: Date;
  fechaFin: Date;
  reportId: string;
  incloureImatges: boolean;
}
